import ListItem from '@tiptap/extension-list-item'

export const CustomListItem = ListItem.extend({
  content: '(paragraph|heading) block*'
})
